import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { Slot } from '../types';
//
// Список слотов для назначения встреч
//
export type SlotsState = Slot[];
const initialState = [] as SlotsState; 

export const slotsSlice = createSlice({
    name: 'slots',
    initialState,
    reducers: {
        slotsSet: (state, action: PayloadAction<SlotsState>) => {
            return action.payload;
        },
    }
});

export const { slotsSet } = slotsSlice.actions;
export default slotsSlice.reducer;
